import shuffle from 'lodash/shuffle';

import { ACTION_TYPES } from '../action/channel';
import { actions as accountActions } from '@wetransfer/transfer/store/action/account';
import Transform from '@wetransfer/transfer/transformers';

export default function (state = {}, action) {
  const { type } = action;

  switch (type) {
    case accountActions.ACCOUNT_UPDATE_SUCCESS: {
      const account = Transform.account(action.details);

      return {
        ...state,
        defaultRecipient: account.default_recipient_email,
      };
    }

    case ACTION_TYPES.SET_WALLPAPERS:
      return {
        ...state,
        // We want to shuffle, so that we show the wallpapers
        // in a random order every time users go to a channel.
        wallpapers: shuffle(action.wallpapers),
      };
  }

  return state;
}
